define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var PhoneNumberStatusModel = /** @class */ (function () {
        function PhoneNumberStatusModel(data) {
            this.Id = ko.observable(0);
            this.Name = ko.observable();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, PhoneNumberStatusModel.Mapping, self);
            }
        }
        PhoneNumberStatusModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new PhoneNumberStatusModel(options.data);
            }
        };
        return PhoneNumberStatusModel;
    }());
    return PhoneNumberStatusModel;
});
//# sourceMappingURL=PhoneNumberStatusModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/PhoneNumberStatusModel.js
// module id = 229
// module chunks = 2